import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const TextWithPadding = styled(Typography)(
  ({ theme }) => `
  padding: ${theme.spacing(2, 4)};
`,
);

export default TextWithPadding;